import React from "react";

const EmptyState = ({ message = "No data found", sub = "Try adjusting the date or filters" }) => (
  <div style={{
    display: "flex", flexDirection: "column", alignItems: "center",
    justifyContent: "center", padding: "52px 24px", textAlign: "center",
  }}>
    <div style={{
      width: 76, height: 76, borderRadius: 22,
      background: "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 34, marginBottom: 18,
      boxShadow: "0 4px 20px rgba(99,102,241,0.14)",
    }}>
      📭
    </div>
    <p style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700, color: "#374151", letterSpacing: -0.2 }}>
      {message}
    </p>
    <span style={{ fontSize: 12, color: "#9CA3AF", fontWeight: 500 }}>{sub}</span>
  </div>
);

export default EmptyState;
